module.exports = __webpack_public_path__ + "img/davey-institute-logo.4ccbaf3f.png";